// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { QueryClient } from '@tanstack/react-query';

/**
 * Centralized helper to invalidate all inventory-related queries.
 *
 * Call this after any operation that changes inventory quantities or locations:
 * - Adjusting inventory (increase/decrease)
 * - Transferring inventory between locations
 * - Receiving shipments
 * - Creating/consuming assemblies
 * - Any other inventory mutations
 *
 * This ensures all inventory views and checks are refreshed with current data.
 *
 * @param queryClient - The TanStack Query client instance
 */
export function invalidateInventory(queryClient: QueryClient): void {
  // Invalidate main inventory queries used by /inventory page and other views
  void queryClient.invalidateQueries({ queryKey: ['inventory'] });

  // Invalidate inventory check queries used by dialogs to show available quantities
  void queryClient.invalidateQueries({ queryKey: ['inventory-check'] });

  // Invalidate item movement history queries
  // Uses predicate to match ['item', itemKey, 'movement', ...] pattern
  void queryClient.invalidateQueries({
    predicate: (query) =>
      Array.isArray(query.queryKey) &&
      query.queryKey[0] === 'item' &&
      query.queryKey[2] === 'movement',
  });
}
